<template>
    <v-dialog max-width="50%" v-model="dialog">
        <v-card min-width="500px">
            <v-card-actions class="ma-0 pa-0 pb-3">
                <v-card-text class="blue--text">{{packageId}}</v-card-text>
                <v-spacer></v-spacer>
                <v-btn icon class="ma-2 pa-0" color="red" @click="onClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-actions>
            <v-card-actions class="ma-0 pa-0 mx-3">
                <v-autocomplete
                        v-model="aud"
                        dense
                        :items="audiences"
                        outlined
                        item-text="name"
                        item-value="name"
                        return-object
                        small-chips
                        multiple
                        deletable-chips
                        label="Audiences"
                ></v-autocomplete>
            </v-card-actions>
            <v-card-actions dense class="ma-0 pa-0 mx-3">
                <v-card elevation="0" class="ma-0 pa-0" width="100%">
                    <common-version-input ref="common-version-input"
                                          :min="[1,0,0]"
                                          :max="[2,0,0]"></common-version-input>
                </v-card>
            </v-card-actions>
            <v-card-actions dense class="ma-0 pa-0 mt-7 pb-3">
                <v-spacer></v-spacer>
                <v-btn :loading="working"
                       elevation="0"
                        class="ma-2"
                        color="primary"
                        @click="onPressActivate">ACTIVATE
                </v-btn>
                <v-spacer></v-spacer>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import {PackageStoreUtils} from "@/modules/mpackages/database/PackageStoreUtils";
import CommonVersionInput from "@/modules/mpackages/views/popups/common/common-version-input";
import {AudienceTestStoreUtils} from "@/modules/maudiences/database/AudienceTestStoreUtils";
import {PermissionsStoreUtils} from "@/modules/mpermissions/database/PermissionsStoreUtils";
import {SlackLogManager} from "@/common/SlackLogManager";

export default {
    name: "p-packages-deploy-popup",
    components: {CommonVersionInput},
    data: () => ({
        dialog: false,
        working:false,
        packageId:'',
        aud:[],
    }),
    computed: {
        audiences(){
            let aud = []
            aud = aud.concat(AudienceTestStoreUtils.getAudiences())
            aud = aud.concat(AudienceTestStoreUtils.getCustomAudiences())
            return aud
        }
    },
    methods: {
        show(packageId) {
            this.packageId = packageId
            this.dialog = true
        },
        hide() {
            this.dialog = false
        },
        onClose(){
            this.dialog = false
        },
        onPressActivate(){

            if (this.aud.length == 0) {
                this.$notify({title: 'No audiences!', type: "error"});
                return;
            }

            let version = this.$refs['common-version-input'].validate()
            if (version.length == 0) {
                this.$notify({title: 'No version!', type: "error"});
                return;
            }

            console.log(version)

            let data = {}
            data.packageId = this.packageId
            data.aud = this.aud.map(e=>e.name).join(',')
            data.minver = version[0].join(".")
            data.maxver = version[1].join(".")

            console.log(data)

            this.working = true
            PackageStoreUtils.deployPackage(data)
            .then(() => {
                this.working = false
                this.dialog = false
                this.$notify({title: 'Package activated!', text: "", type: "success"});
                this.slackDeployLog(this.packageId);
            })
            .catch((error) => {
                this.working = false
                this.$notify({title: 'Error get file!', text: error, type: "error"});
            })
        },
        slackDeployLog(packageId){
            let deployData = {
                'icon_emoji': ':hammer:',
                'text': "<@"+PermissionsStoreUtils.getMyName()+"> activate package",
                'attachments': [{
                    'color': '#3ac94b',
                    'fields': [
                        {"title": "Environment", 'value': SlackLogManager.getEnv(), 'short': true},
                        {"title": "Id", 'value': packageId, 'short': true},
                    ]
                }]
            }
            SlackLogManager.log(deployData)
        },
    }
}
</script>

<style scoped>

</style>